export default "__VITE_ASSET__2dda3a25__"